const state = {
    exchangeObj:null,
 
 
  

};

const getters = {
   GET_EXCHANGE_OBJ: (state) => {
       return state.exchangeObj;
   },
 

   


};


const actions = {

   CLEAR_EXCHANGE_DETAIL_STORE: ({ commit }) => {
       commit('clearExchangeDetailStore');
   },

   
  ///single ticketing queue object
   SET_EXCHANGE_OBJ: ({ commit }, val) => {

       commit('saveExchangeObj', val);

   },

  
  

};


const mutations = {
   clearExchangeDetailStore: (state) => {
    
       state.exchangeObj = null;
     


   },
  
   saveExchangeObj: (state, val) => {
       state.exchangeObj = val;
   },

  

};


export default {
   namespaced: true,
   state,
   getters,
   actions,
   mutations
}